import React from 'react'
import { Button, Popup } from 'semantic-ui-react'

const CustomTooltip = ({className,children,title, btnId}) => (
  <Popup className={className}
    on='click'
    position='bottom left'
    trigger={<Button basic
        color="blue"
        className="action-btn"
        id={btnId}
        >
            {title}
        </Button>}
  >
      <Popup.Content>
       {children}
      </Popup.Content>
  </Popup>
)

export default CustomTooltip